import React from 'react';

export type Props = {
  children: React.ReactNode;
  x?: number;
  onClick: () => void;
};

const Column = ({ children, onClick, x }: Props) => {
  return (
    <pixiContainer
      eventMode="static"
      cursor="pointer"
      sortableChildren
      onPointerTap={onClick}
      x={x}
    >
      {children}
    </pixiContainer>
  );
};

export default Column;
